import React, { useCallback, useId, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import Fieldset from '@rover/components/src/formFields/Fieldset';
import SingleSelectButtonGroup from '@rover/components/src/formFields/SingleSelectButtonGroup';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import FilterLabel from '@rover/shared/js/search/components/FilterLabel';

import { SearchInterstitialGetsAlongCats } from '../Collections/Wizard/analyticsEvents';
import { TogglePreference } from '..';

type Props = {
  displayAsToggle?: boolean;
  onChange: (arg0: boolean) => void;
  value?: boolean;
};

export type SelectedValue = 'yes' | 'no' | 'unsure';

const CatPreferences = ({ displayAsToggle, onChange, value = true }: Props): JSX.Element => {
  const id = useId();
  const [singleSelectValue, setSingleSelectValue] = useState<SelectedValue>(value ? 'no' : 'yes');

  const CAT_PREFERENCES_OPTIONS = [
    {
      value: 'yes',
      submitValue: false,
      title: t`Yes`,
    },
    {
      value: 'no',
      submitValue: true,
      title: t`No`,
    },
    {
      value: 'unsure',
      submitValue: false,
      title: t`Unsure`,
    },
  ];

  const handleSingleSelectChange = useCallback(
    (selectedValue: SelectedValue): void => {
      const clickedOption = CAT_PREFERENCES_OPTIONS.find(
        (option) => option.value === selectedValue
      );
      onChange(clickedOption ? clickedOption.submitValue : false);
      setSingleSelectValue(selectedValue);
    },
    [onChange]
  );

  return displayAsToggle ? (
    <TogglePreference
      label={t`My dogs don’t like cats`}
      onChange={(toggledValue) => {
        emitAnalyticsEvent(
          new SearchInterstitialGetsAlongCats({ getsAlongCats: toggledValue ? 'no' : 'yes' })
        );
        onChange(toggledValue);
      }}
      value={value}
    />
  ) : (
    <Fieldset aria-labelledby={id}>
      <FilterLabel id={id}>
        <Trans>Do your dogs get along with cats?</Trans>
      </FilterLabel>
      <SingleSelectButtonGroup
        buttons={CAT_PREFERENCES_OPTIONS}
        id={id}
        onChange={(chosenOption) => {
          emitAnalyticsEvent(new SearchInterstitialGetsAlongCats({ getsAlongCats: chosenOption }));
          handleSingleSelectChange(chosenOption);
        }}
        value={singleSelectValue as SelectedValue}
      />
    </Fieldset>
  );
};

export default CatPreferences;
